import '../../App.css';
import React, { useContext, useState, useEffect } from 'react';
import { ApiContext } from '../../context/ApiContext';
import { StyleContext } from '../../context/StyleContext';
import { Tab, Tabs, Row, Col } from 'react-bootstrap'
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral';
import Footer from '../../components/footer/Footer'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TfiFilter } from "react-icons/tfi";
import { InputLabel, MenuItem, FormControl, Select, Menu, Badge } from '@mui/material'
import Perspectivas from '../../components/graficos/Perspectivas';
import Impacto from '../../components/graficos/Impacto';
import Swot from '../../components/graficos/swot/Swot';
import Indice from '../../components/graficos/swot/Indice';
import AnaliseGeral from '../../components/graficos/swot/AnaliseGeral';
import RadarAnalise from '../../components/graficos/swot/RadarAnalise';
import Principais from '../../components/graficos/swot/Principais';
import SemTitulo from '../../components/graficos/swot/SemTitulo';
import SwotTI from '../../components/graficos/swotTI/SwotTI';
import IndiceTI from '../../components/graficos/swotTI/IndiceTI';
import AnaliseGeralTI from '../../components/graficos/swotTI/AnaliseGeralTI';
import RadarAnaliseTI from '../../components/graficos/swotTI/RadarAnaliseTI';
import PrincipaisTI from '../../components/graficos/swotTI/PrincipaisTI';
import SemTituloTI from '../../components/graficos/swotTI/SemTituloTI';
import DemandasXCapacidades from '../../components/graficos/DemandasXCapacidades';
import SistemasXDemandas from '../../components/graficos/SistemasXDemandas';
import ArvoreCapacidade from '../../components/graficos/ArvoreCapacidade';
import BscXSwotXGut from '../../components/graficos/BscXSwotXGut';
import CustoXDemandas from '../../components/graficos/CustoXDemandas';
import EmptyFolder from '../../components/EmptyFolder';
import OrdemPrioridade from '../../components/graficos/OrdemPrioridade';
import PessoaXDemandas from '../../components/graficos/PessoaXDemandas';
import CustoXTempo from '../../components/graficos/CustoXTempo';
import SistemaXCapacidades from '../../components/graficos/SistemaXCapacidades';
import BscXSwotXGutXDemanda from '../../components/graficos/BscXSwotXGutXDemanda';
import MapaCalor from '../../components/graficos/MapaCalor';
import MatrizTime from '../../components/graficos/MatrizTime';
import Relacionamentos from '../../components/graficos/Relacionamentos';
import { DashboardContext } from '../../context/DashboardContext';
import Cookies from 'js-cookie'
import { AuthContext } from '../../context/AuthContext';

function Dashboard() {
    const { ObterBSC, SwotRelatorio, ListaRelatorio, ListaRelatorioSwotTi, SwotTiRelatorio, ObterCicloValido, CicloValido, ListaBSC, BSCs, ListaMatriz, ListaMatrizTi, ListaSwotPorCiclo, SwotPorCiclo, ListaSwotTiPorCiclo, SwotTiPorCiclo, DiretrizEstrategica, setCicloValido } = useContext(ApiContext)
    const { ListaGraficosFavoritos, Favoritos, getSwot, getSwotTi, Success, Error } = useContext(DashboardContext)
    const { btnCriar, btnVer, corSecundaria } = useContext(StyleContext)
    const { setEmpresaKey, EmpresaKey } = useContext(AuthContext)
    const [bscKey, setBscKey] = useState(JSON.stringify({ descricao: "", key: "" }));
    const [bscKeyPadrao, setBscKeyPadrao] = useState(JSON.stringify({ descricao: "", key: "" }))
    const [swotKey, setSwotKey] = useState(JSON.stringify({ descricao: "", key: "" }));
    const [swotTiKey, setSwotTiKey] = useState(JSON.stringify({ descricao: "", key: "" }));
    const [isLoading, setIsLoading] = useState(false)
    const [badge, setBadge] = useState(0)

    const corFavorito = (nome) => {
        return Favoritos?.some((item) => item.nomeGrafico === nome) ? false : true;
    };

    // Sincronizar EmpresaKey do Cookie ao montar o componente
    useEffect(() => {
        const empresaKey = Cookies.get("Key");
        if (empresaKey && !EmpresaKey) {
            setEmpresaKey(empresaKey);
        }
    }, []);

    // Carregar dados do ciclo válido quando EmpresaKey estiver disponível
    useEffect(() => {
        const empresaKey = EmpresaKey || Cookies.get("Key");

        if (!empresaKey) {
            console.warn("Dashboard: empresaKey não encontrada no contexto nem nos cookies");
            return;
        }

        let mounted = true;

        (async () => {
            try {
                setIsLoading(true);
                setBscKey("");
                setBscKeyPadrao("");
                setSwotKey("");
                setSwotTiKey("");

                const ciclo = await ObterCicloValido(empresaKey);
                if (!mounted || !ciclo) return;

                setCicloValido(ciclo);

                await Promise.all([
                    ListaBSC(ciclo.key),
                    ListaSwotPorCiclo(ciclo.id),
                    ListaSwotTiPorCiclo(ciclo.id),
                    ListaGraficosFavoritos(),
                ]);
            } catch (err) {
                setIsLoading(false);
                console.error("Erro ao carregar dados do Dashboard:", err);
            } finally {
                if (mounted) setIsLoading(false);
            }
        })();

        return () => {
            mounted = false;
        };
    }, [EmpresaKey]);

    useEffect(() => {
        if (!BSCs?.length) return;

        const empresaAtual = Cookies.get("Key");

        const padrao = BSCs.find((item) => item.padrao);
        if (padrao) {
            setBscKeyPadrao(JSON.stringify({ descricao: padrao.descricao, key: padrao.key }));
        } else {
            setBscKeyPadrao("");
        }
    }, [BSCs]);

    useEffect(() => {
        if (bscKeyPadrao !== "") {
            const parsedKey = JSON.parse(bscKeyPadrao);
            ObterBSC(parsedKey.key)
        }
        try {
            if (bscKey) {
                const parsedKey = JSON.parse(bscKey);
                if (parsedKey.key) {
                    ObterBSC(parsedKey.key);
                }
            }
        } catch (error) {
            console.error("Erro ao fazer o parse de bscKey: ", error);
        }
    }, [bscKeyPadrao, bscKey]);

    useEffect(() => {
        try {
            if (swotKey) {
                const parsedKey = JSON.parse(swotKey)
                if (parsedKey?.key) {
                    ListaRelatorio(parsedKey?.key)
                    ListaMatriz(parsedKey?.key)
                    getSwot(parsedKey?.key)
                }
            }
        } catch (error) {
            console.error("Erro ao fazer o parse de swotKey: ", error);
        }
    }, [swotKey])

    useEffect(() => {
        try {
            if (swotTiKey) {
                const parsedKey = JSON.parse(swotTiKey)
                if (parsedKey?.key) {
                    ListaRelatorioSwotTi(parsedKey?.key)
                    ListaMatrizTi(parsedKey?.key)
                    getSwotTi(parsedKey?.key)
                }
            }
        } catch (error) {
            console.error("Erro ao fazer o parse de swotTiKey: ", error);
        }
    }, [swotTiKey])

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if ((bscKey || bscKeyPadrao) && (swotKey || swotTiKey)) {
            return setBadge(0)
        } else if ((bscKey || bscKeyPadrao) || (swotKey || swotTiKey)) {
            return setBadge(1)
        } else {
            setBadge(2)
        }
    }, [swotKey, swotTiKey, bscKey])

    const cleanFilter = () => {
        setBscKey("")
        setSwotKey("")
        setSwotTiKey("")
    }

    return (
        <div>
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <Header pagina={'Dashboard'} dashboard={true} bscKey={bscKey} bscKeyPadrao={bscKeyPadrao} swotKey={swotKey} swotTiKey={swotTiKey}></Header>
            <MenuLateral></MenuLateral>
            <div className='container-dashboard'>
                {/* {isLoading ?
                    <div className="loading-screen" >
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                    : */}
                <div style={{ display: 'flex', alignItems: 'flex-start', width: '100%', gap: '15px' }}>
                    <div style={{ '--cor-secundaria': corSecundaria || '#0F6631', width: '100%' }}>
                        <Tabs
                            defaultActiveKey="mapacalor"
                            className='mb-3'
                            justify
                            variant='pills'
                        >
                            <Tab eventKey="mapacalor" title="Mapa de Calor">
                                {/* {CicloValido ? (
                                        <>
                                            {bscKeyPadrao || bscKey ? (
                                                DiretrizEstrategica && (
                                                    <> */}
                                <Row style={{ gap: '20px', marginBottom: '20px' }}>
                                    <Col className='section-bsc-grafico'>
                                        <MapaCalor corFavorito={corFavorito} DiretrizEstrategica={DiretrizEstrategica} tab={"bsc"} />
                                    </Col>
                                </Row>
                                {/* </> */}
                                {/* )
                                            ) : (
                                                <EmptyFolder texto={"BSC"} />
                                            )}
                                        </>
                                    ) : (
                                        <EmptyFolder texto={"ciclo"} />
                                    )} */}
                            </Tab>
                            <Tab eventKey="matriztime" title="Matriz de Avaliação">
                                <Row style={{ gap: '20px', marginBottom: '20px' }}>
                                    <Col className='section-bsc-grafico'>
                                        <MatrizTime corFavorito={corFavorito} cicloDemandaKey={CicloValido ? CicloValido?.key : ""} tab={"matriz"} />
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="relacionamentos" title="Relacionamentos" mountOnEnter>
                                <Row style={{ gap: '20px', marginBottom: '20px' }}>
                                    <Col className='section-bsc-grafico'>
                                        <Relacionamentos corFavorito={corFavorito} />
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="bsc" title="BSC">
                                {CicloValido ? (
                                    <>
                                        {bscKeyPadrao || bscKey ? (
                                            DiretrizEstrategica && (
                                                <>
                                                    <Row style={{ gap: '20px', marginBottom: '20px' }}>
                                                        <Col className='section-bsc-grafico'>
                                                            <Perspectivas corFavorito={corFavorito} DiretrizEstrategica={DiretrizEstrategica} tab={"bsc"} />
                                                        </Col>
                                                        <Col className='section-bsc-grafico'>
                                                            <Impacto corFavorito={corFavorito} tab={"bsc"} />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <OrdemPrioridade corFavorito={corFavorito} DiretrizEstrategica={DiretrizEstrategica} tab={"bsc"} />
                                                    </Row>
                                                </>
                                            )
                                        ) : (
                                            <EmptyFolder texto={"BSC"} />
                                        )}
                                    </>
                                ) : (
                                    <EmptyFolder texto={"ciclo"} />
                                )}
                            </Tab>
                            <Tab eventKey="swot" title="SWOT">
                                {CicloValido ? (
                                    <>
                                        {swotKey ? (
                                            SwotRelatorio && (
                                                <>
                                                    <Row className='section-bsc-grafico-swot' style={{ marginBottom: '20px' }}>
                                                        <Swot corFavorito={corFavorito} tab={"swot"} swotKey={swotKey} />
                                                    </Row>
                                                    <Row className='section-bsc-grafico' style={{ marginBottom: '20px', padding: '0' }}>
                                                        <Indice corFavorito={corFavorito} tab={"swot"} />
                                                    </Row>
                                                    <Row style={{ display: 'flex', height: '100%', justifyContent: 'space-between', gap: '20px', marginBottom: '20px' }}>
                                                        <Col className='section-bsc-grafico'>
                                                            <AnaliseGeral corFavorito={corFavorito} />
                                                        </Col>
                                                        <Col className='section-bsc-grafico'>
                                                            <RadarAnalise corFavorito={corFavorito} tab={"swot"} />
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ display: 'flex', height: '100%', justifyContent: 'space-between', gap: '20px', marginBottom: '20px' }}>
                                                        <Col className='section-bsc-grafico'>
                                                            <Principais corFavorito={corFavorito} />
                                                        </Col>
                                                        <Col className='section-bsc-grafico'>
                                                            <SemTitulo corFavorito={corFavorito} />
                                                        </Col>
                                                    </Row>
                                                </>
                                            )
                                        ) : (
                                            <EmptyFolder texto={"SWOT"} />
                                        )}
                                    </>
                                ) : (
                                    <EmptyFolder texto={"ciclo"} />
                                )}
                            </Tab>
                            <Tab eventKey="swotTI" title="SWOT de TI">
                                {CicloValido ? (
                                    <>
                                        {swotTiKey ? (
                                            SwotTiRelatorio && (
                                                <>
                                                    <Row className='section-bsc-grafico-swot' style={{ marginBottom: '20px' }}>
                                                        <SwotTI corFavorito={corFavorito} tab={"swotTi"} swotTiKey={swotTiKey} />
                                                    </Row>
                                                    <Row className='section-bsc-grafico' style={{ marginBottom: '20px', padding: '0' }}>
                                                        <IndiceTI corFavorito={corFavorito} tab={"swotTi"} />
                                                    </Row>
                                                    <Row style={{ display: 'flex', height: '100%', justifyContent: 'space-between', gap: '20px', marginBottom: '20px' }}>
                                                        <Col className='section-bsc-grafico'>
                                                            <AnaliseGeralTI corFavorito={corFavorito} />
                                                        </Col>
                                                        <Col className='section-bsc-grafico'>
                                                            <RadarAnaliseTI corFavorito={corFavorito} tab={"swotTi"} />
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ display: 'flex', height: '100%', justifyContent: 'space-between', gap: '20px', marginBottom: '20px' }}>
                                                        <Col className='section-bsc-grafico'>
                                                            <PrincipaisTI corFavorito={corFavorito} />
                                                        </Col>
                                                        <Col className='section-bsc-grafico'>
                                                            <SemTituloTI corFavorito={corFavorito} />
                                                        </Col>
                                                    </Row>
                                                </>
                                            )
                                        ) : (
                                            <EmptyFolder texto={"SWOT de TI"} />
                                        )}
                                    </>
                                ) : (
                                    <EmptyFolder texto={"ciclo"} />
                                )}
                            </Tab>
                            <Tab eventKey="capacidades" title="Capacidades">
                                {CicloValido ? (
                                    <>
                                        {swotKey ? (
                                            <>
                                                <Row className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                    <DemandasXCapacidades corFavorito={corFavorito} swotKey={swotKey ? JSON.parse(swotKey).key : ""} tab={"capacidade"} />
                                                    {/* <Col className='section-bsc-grafico'>
                                                            <SistemasXDemandas corFavorito={corFavorito} cicloDemandaKey={CicloValido ? CicloValido.key : ""} tab={"capacidade"} />
                                                        </Col> */}
                                                </Row>
                                                <Row className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                    <SistemaXCapacidades corFavorito={corFavorito} swotKey={swotKey ? JSON.parse(swotKey).key : ""} tab={"sistema"} />
                                                </Row>
                                                <Row style={{ display: 'flex', height: '100%', justifyContent: 'space-between', gap: '20px', marginBottom: '20px' }}>
                                                    <Col className='section-bsc-grafico'>
                                                        <ArvoreCapacidade corFavorito={corFavorito} cicloDemandaKey={CicloValido ? CicloValido.key : ""} tab={"capacidade"} />
                                                    </Col>
                                                </Row>
                                            </>
                                        ) : (
                                            <EmptyFolder texto={"SWOT"} />
                                        )}
                                    </>
                                ) : (
                                    <EmptyFolder texto={"ciclo"} />
                                )}
                            </Tab>
                            <Tab eventKey="demandas" title="Iniciativas">
                                {CicloValido ? (
                                    <>
                                        {swotKey ? (
                                            <>
                                                <Row className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                    <BscXSwotXGut corFavorito={corFavorito} cicloDemandaKey={CicloValido ? CicloValido.key : ""} swotKey={swotKey ? JSON.parse(swotKey).key : ""} tab={"demandas"} />
                                                </Row>
                                                <Row className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                    <BscXSwotXGutXDemanda corFavorito={corFavorito} cicloDemandaKey={CicloValido ? CicloValido.key : ""} swotKey={swotKey ? JSON.parse(swotKey).key : ""} tab={"demandas"} />
                                                </Row>
                                                <Row className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                    <PessoaXDemandas corFavorito={corFavorito} swotKey={swotKey ? JSON.parse(swotKey).key : ""} cicloDemandaKey={CicloValido ? CicloValido.key : ""} tab={"pessoa"} />
                                                </Row>
                                            </>
                                        ) : (
                                            <EmptyFolder texto={"SWOT"} />
                                        )}
                                    </>
                                ) : (
                                    <EmptyFolder texto={"ciclo"} />
                                )}
                            </Tab>
                            {/* <Tab eventKey="custos" title="Financeiro">
                                    {CicloValido ?
                                        <>
                                            <Row style={{ display: 'flex', height: '100%', justifyContent: 'space-between', gap: '20px', marginBottom: '20px' }}>
                                                <Col className='section-bsc-grafico'>
                                                    <CustoXDemandas corFavorito={corFavorito} cicloDemandaKey={CicloValido ? CicloValido.key : ""} tab={"custos"} />
                                                </Col>
                                                <Col className='section-bsc-grafico'>
                                        <BudgetDemandas corFavorito={corFavorito} />
                                        </Col>
                                            </Row>
                                            <Row style={{ display: 'flex', height: '100%', justifyContent: 'space-between', gap: '20px', marginBottom: '20px' }}>
                                                <Col className='section-bsc-grafico'>
                                                    <CustoXTempo corFavorito={corFavorito} cicloDemandaKey={CicloValido ? CicloValido.key : ""} tab={"tempo"} />
                                                </Col>
                                            </Row>
                                        </>
                                        :
                                        <EmptyFolder texto={"ciclo"} />
                                    }
                                </Tab> */}
                            <Tab eventKey="inicio" title="Favoritos">
                                {CicloValido ?
                                    <></>
                                    :
                                    <EmptyFolder texto={"ciclo"} />
                                }
                                {CicloValido &&
                                    <>
                                        {(bscKey || bscKeyPadrao) && (swotKey || swotTiKey) ?
                                            <>
                                                {Favoritos.length > 0 ?
                                                    <>
                                                        {Favoritos?.map((item, index) => {
                                                            return (
                                                                <div key={index}>
                                                                    <Row>
                                                                        {/* {item.nomeGrafico == "Perspectivas" &&
                                                                                <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                    <Perspectivas corFavorito={corFavorito} DiretrizEstrategica={DiretrizEstrategica} tab={"inicio"} />
                                                                                </Col>
                                                                            } */}
                                                                        {item.nomeGrafico == "Ordem" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <OrdemPrioridade corFavorito={corFavorito} DiretrizEstrategica={DiretrizEstrategica} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {item.nomeGrafico == "Impacto Objetivos do Negócio" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <Impacto corFavorito={corFavorito} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {/* {item.nomeGrafico == "Perspectiva Aprendizado e Crescimento" &&
                                                                                <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                    <Aprendizado corFavorito={corFavorito} />
                                                                                </Col>
                                                                            } */}
                                                                        {SwotRelatorio && item.nomeGrafico == "SWOT" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <Swot corFavorito={corFavorito} tab={"inicio"} swotKey={swotKey} />
                                                                            </Col>
                                                                        }
                                                                        {SwotRelatorio && item.nomeGrafico == "Índice de favorabilidade" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px', padding: '0' }}>
                                                                                <Indice corFavorito={corFavorito} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {SwotRelatorio && item.nomeGrafico == "Análise Geral" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <AnaliseGeral corFavorito={corFavorito} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {SwotRelatorio && item.nomeGrafico == "Radar da Análise" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <RadarAnalise corFavorito={corFavorito} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {SwotRelatorio && item.nomeGrafico == "Principais ameaças" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <Principais corFavorito={corFavorito} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {SwotRelatorio && item.nomeGrafico == "Análise Capacidades" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <SemTitulo corFavorito={corFavorito} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {SwotTiRelatorio && item.nomeGrafico == "SWOT de TI" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <SwotTI corFavorito={corFavorito} tab={"inicioTi"} swotTiKey={swotTiKey} />
                                                                            </Col>
                                                                        }
                                                                        {SwotTiRelatorio && item.nomeGrafico == "Índice de favorabilidade de TI" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px', padding: '0' }}>
                                                                                <IndiceTI corFavorito={corFavorito} tab={"inicioTi"} />
                                                                            </Col>
                                                                        }
                                                                        {SwotTiRelatorio && item.nomeGrafico == "Análise Geral de TI" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <AnaliseGeralTI corFavorito={corFavorito} tab={"inicioTi"} />
                                                                            </Col>
                                                                        }
                                                                        {SwotTiRelatorio && item.nomeGrafico == "Radar da Análise de TI" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <RadarAnaliseTI corFavorito={corFavorito} tab={"inicioTi"} />
                                                                            </Col>
                                                                        }
                                                                        {SwotTiRelatorio && item.nomeGrafico == "Principais ameaças de TI" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <PrincipaisTI corFavorito={corFavorito} tab={"inicioTi"} />
                                                                            </Col>
                                                                        }
                                                                        {SwotTiRelatorio && item.nomeGrafico == "Análise Capacidades de TI" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <SemTituloTI corFavorito={corFavorito} tab={"inicioTi"} />
                                                                            </Col>
                                                                        }
                                                                        {item.nomeGrafico == "Demandas x Capacidades de negócios" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <DemandasXCapacidades corFavorito={corFavorito} swotKey={swotKey ? JSON.parse(swotKey).key : ""} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {item.nomeGrafico == "Sistema x Capacidades de negócios" &&
                                                                            // <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                            //     <SistemasXDemandas corFavorito={corFavorito} cicloDemandaKey={CicloValido ? CicloValido.key : ""} tab={"inicio"} />
                                                                            // </Col>
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <SistemaXCapacidades corFavorito={corFavorito} swotKey={swotKey ? JSON.parse(swotKey).key : ""} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {/* {item.nomeGrafico == "Capacidades de negócios por Demanda e Área" &&
                                                                                <Col lg={6} className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                    <CapacidadeXDemandaXArea corFavorito={corFavorito} />
                                                                                </Col>
                                                                            } */}
                                                                        {item.nomeGrafico == "Árvore de Capacidades" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <ArvoreCapacidade corFavorito={corFavorito} cicloDemandaKey={CicloValido ? CicloValido.key : ""} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {item.nomeGrafico == "BSC" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <BscXSwotXGut corFavorito={corFavorito} cicloDemandaKey={CicloValido ? CicloValido.key : ""} swotKey={swotKey ? JSON.parse(swotKey).key : ""} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {item.nomeGrafico == "Pessoa x Demandas" &&
                                                                            <Col className='section-bsc-grafico'>
                                                                                <PessoaXDemandas corFavorito={corFavorito} swotKey={swotKey ? JSON.parse(swotKey).key : ""} cicloDemandaKey={CicloValido ? CicloValido.key : ""} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {/* {item.nomeGrafico == "Demandas dependentes de outras demandas" &&
                                                                                <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                    <DemandaDependente corFavorito={corFavorito} />
                                                                                </Col>
                                                                            } */}
                                                                        {item.nomeGrafico == "Custo x Demandas" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <CustoXDemandas corFavorito={corFavorito} cicloDemandaKey={CicloValido ? CicloValido.key : ""} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {item.nomeGrafico == "Custo x Tempo" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <CustoXTempo corFavorito={corFavorito} cicloDemandaKey={CicloValido ? CicloValido.key : ""} tab={"inicio"} />
                                                                            </Col>
                                                                        }
                                                                        {item.nomeGrafico == "Matriz de Avaliação" &&
                                                                            <Col className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                <MatrizTime corFavorito={corFavorito} cicloDemandaKey={CicloValido ? CicloValido?.key : ""} tab={"matriz"} />
                                                                            </Col>

                                                                        }
                                                                        {/* {item.nomeGrafico == "Budget de demandas" &&
                                                                                <Col lg={6} className='section-bsc-grafico' style={{ marginBottom: '20px' }}>
                                                                                    <BudgetDemandas corFavorito={corFavorito} />
                                                                                </Col>
                                                                            } */}
                                                                    </Row>
                                                                </div>
                                                            )
                                                        })}
                                                    </>
                                                    :
                                                    <div style={{ marginTop: "90px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <h2 className='h2-sem-demandas'>Nenhum gráfico adicionado como favorito.</h2>
                                                    </div>
                                                }
                                            </>
                                            :
                                            <EmptyFolder texto={"SWOT"} />
                                        }
                                    </>
                                }
                            </Tab>
                        </Tabs>
                    </div>
                    <Badge badgeContent={badge} color="warning">
                        <button
                            className='btn-dash btn-criar'
                            style={{ ...btnCriar, padding: '8px 10px', borderRadius: '8px' }}
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClick}
                        >
                            <TfiFilter style={{ fontSize: '22px' }} />
                        </button>
                    </Badge>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <h2 className="h2-bsc">Filtros</h2>
                        <MenuItem style={{ width: '320px' }}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">BSC</InputLabel>
                                <Select
                                    className='span-bsc'
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={bscKey || bscKeyPadrao}
                                    label="Ciclo"
                                    onChange={(e) => setBscKey(e.target.value)}
                                >
                                    <MenuItem value="0">Selecionar...</MenuItem>
                                    {CicloValido !== "0" && BSCs?.map((item) => (
                                        <MenuItem key={item.id} value={JSON.stringify({ descricao: item.descricao, key: item.key })}>
                                            {item.descricao ? item.descricao : "-"}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </MenuItem>
                        <MenuItem style={{ width: '320px' }}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">SWOT</InputLabel>
                                <Select
                                    className='span-bsc'
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={swotKey}
                                    label="SWOT"
                                    onChange={(e) => setSwotKey(e.target.value)}
                                >
                                    <MenuItem value="0">Selecionar...</MenuItem>
                                    {CicloValido !== "0" && SwotPorCiclo && SwotPorCiclo?.map((item, index) => (
                                        <MenuItem key={index} value={JSON.stringify({ descricao: item.descricao, key: item.key })}>
                                            {item.descricao ? item.descricao : "-"}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </MenuItem>
                        <MenuItem style={{ width: '320px' }}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">SWOT de TI</InputLabel>
                                <Select
                                    className='span-bsc'
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={swotTiKey}
                                    label="SWOT de TI"
                                    onChange={(e) => setSwotTiKey(e.target.value)}
                                >
                                    <MenuItem value="0">Selecionar...</MenuItem>
                                    {CicloValido !== "0" && SwotTiPorCiclo && SwotTiPorCiclo?.map((item, index) => (
                                        <MenuItem key={index} value={JSON.stringify({ descricao: item.descricao, key: item.key })}>
                                            {item.descricao ? item.descricao : "-"}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </MenuItem>
                        <div style={{ marginTop: '20px' }}>
                            <button className='btn-dash btn-criar' style={{ ...btnCriar, width: '90%', padding: '8px 0', marginBottom: '10px' }} onClick={() => handleClose()}>Aplicar</button>
                            <button className='btn-dash btn-ver' style={{ ...btnVer, width: '90%', marginLeft: '15px', padding: '8px 0' }} onClick={() => cleanFilter()}>Limpar</button>
                        </div>
                    </Menu>
                </div>
                {/* } */}
            </div>
            <Footer></Footer>
        </div>
    );

}

export default Dashboard;
